/**
 * Created by liuyang on 17/1/14.
 */
import {
  get,
  isEmpty,
  isString,
  isObject
} from 'lodash';
import {
  MessageBox
} from 'element-ui';
import {
  UserInfoModel
} from '../model/index';
import defer from 'src/class/Defer';
import Vue from 'vue';
const cache = {
  status: 'init',
  callbacks: []
};

export default class User {
  // 用户是否登录
  static userIsLogin(preventDefault, preventDefaultAction) {
    let store = global.__router.app.$store;

    // 如果被reject，则直接不用处理
    let retPromise;
    switch (cache.status) {
      case 'init':
        cache.status = 'pending';
        retPromise = UserInfoModel.getInstance().execute().then((userInfo) => {
          cache.status = 'resolve';
          store.dispatch('setUserInfo', userInfo);
          let current = null;
          while (current = cache.callbacks.pop()) {
            current.resolve(userInfo);
          }
          // 用户登录成功
          Vue.bus.emit('login', userInfo);
          return Promise.resolve(userInfo);
        }, function (status) {
          if ([100, 101].indexOf(get(status, 'errno')) != -1) {
            // 退出登录
            Vue.bus.emit('logout', null);
            cache.status = 'reject';
          } else {
            cache.status = 'init';
          }
          let current = null;
          let info = 'user is not login';
          while (current = cache.callbacks.pop()) {
            current.reject(info);
          }
          return Promise.reject(info)
        });
        break;
      case 'pending':
        let defer1 = defer();
        cache.callbacks.push(defer1);
        retPromise = defer1.promise;
        break;
      case 'resolve':
      case 'reject':
        retPromise = new Promise((resolve, reject) => {
          let userInfo = get(store, 'state.__GLOBAL__STATE__.USERINFO');
          if (isEmpty(userInfo)) {
            reject('user is not login');
          } else {
            resolve(userInfo);
          }
        });
        break;
    }

    return retPromise.catch(() => {
      let preventDefaultData = false;
      let message = '当前页面需要登录后才能操作';
      let title = '登录提示';
      if (isString(preventDefault)) {
        message = preventDefault;
      } else if (isObject(preventDefault)) {
        message = preventDefault.message;
        title = preventDefault.title;
      } else if (preventDefault === true) {
        preventDefaultData = true;
      }
      return preventDefaultData ? Promise.reject('user is not login') : Promise.resolve(MessageBox.confirm(message, title).then((data) => {
        if (preventDefaultAction !== true) {
          global.__router.push({
            name: 'user_login'
          });
        }
        return Promise.reject(data);
      }));
    });
  }

  // 重新获取用户信息
  static refreshUserInfo() {
    let store = global.__router.app.$store;
    cache.status = 'init';
    //localStorage.removeItem('uuid');
    store.dispatch('setUserInfo', null);

    return User.userIsLogin(true, true);
  }

  // 更新用户信息
  static updateUserInfo(userInfo) {
    let store = global.__router.app.$store;
    store.dispatch('updateUserInfo', userInfo);
    cache.status = 'init';
    return Promise.resolve(userInfo);
  }

  // 退出登录
  static logout() {
    let store = global.__router.app.$store;
    cache.status = 'init';
    //localStorage.removeItem('uuid');
    store.dispatch('setUserInfo', null);
    // 触发用户退出登录事件
    Vue.bus.emit('logout', null);
    return Promise.resolve();
  }

  // 登录成功时，回调函数
  static onLogin(callback) {
    Vue.bus.on('login', callback);
  };

  // 登录登录时，定议回调
  static onLogout(callback) {
    Vue.bus.on('logout', callback);
  }

  // 登录成功，只执行一次
  static onceLogin(callback){
    Vue.bus.once('login', callback);
  }

  // 退出登录，只执行一次
  static onceLogout(callback){
    Vue.bus.once('logout', callback);
  }

  // 清除登录成功事件回调
  static offLogin(callback){
    Vue.bus.off('login', callback);
  }

  // 清除退出登录回调
  static offLogout(callback){
    Vue.bus.off('logout', callback);
  }
}



// WEBPACK FOOTER //
// ./src/service/User.js